import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Construction, ArrowRight } from "lucide-react";
import TechSummary from "@/components/technique/TechSummary";

export default function TechProjectTab({ projectId }) {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get(`/technique/by-project/${projectId}`).then((r) => setD(r.data)).catch(() => setD({ error: true }));
  }, [projectId]);
  if (!d) return <div className="py-8 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-brand-500" /></div>;
  if (d.error) return <p className="py-6 text-center text-sm text-slate-400">Accès au module Technique non autorisé.</p>;
  return (
    <div className="space-y-3" data-testid="cp-technique-panel">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2"><Construction className="h-4 w-4 text-brand-600" />
          <span className="text-sm font-semibold">Informations techniques (lecture seule)</span>
          {d.file && <span className="font-mono text-xs text-slate-400">{d.file.numero}</span>}
        </div>
        {d.file && d.accessible && <Button variant="outline" onClick={() => nav(`/technique/dossier/${d.file.id}`)} data-testid="tech-open-link">
          Voir dans le Suivi technique<ArrowRight className="h-4 w-4 ml-1.5" /></Button>}
      </div>
      {d.file ? <>
        <p className="text-sm text-slate-600" data-testid="cp-tech-technicien">Technicien affecté : <b>{d.file.technicien_name || "non affecté"}</b></p>
        <TechSummary file={d.file} summary={d.summary} />
      </> : (
        <p className="text-sm text-slate-500 rounded-lg border border-dashed p-4">Aucun suivi technique pour ce projet. Le service technique l'ouvre depuis Technique → Suivi technique.</p>
      )}
    </div>
  );
}
